import deleteAnnualValue from 'utils/deleteAnnualValue';

export default [
  {
    icon: 'ni-trash',
    text: 'Eliminar',
    action: deleteAnnualValue,
  },
];
